/**
 * Visual Discount Custom Element
 * Handles dynamic visual discount display and validation
 */
class VisualDiscount extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    // Avoid re-initializing if already done
    if (this.initialized) return;
    this.initialized = true;

    // Listen for variant changes on the product page
    if (this.dataset.productId) {
      this.setupVariantListener();
    }
  }

  setupVariantListener() {
    // Listen for variant change events
    document.addEventListener('variant:changed', (event) => {
      if (event.detail && event.detail.variant) {
        this.updatePrices(event.detail.variant);
      }
    });

    // Also listen for form changes as a fallback
    const productForm = document.querySelector(`form[data-product-id="${this.dataset.productId}"]`);
    if (productForm) {
      productForm.addEventListener('change', () => {
        // Small delay to allow variant data to update
        setTimeout(() => this.checkAndUpdatePrices(), 100);
      });
    }
  }

  checkAndUpdatePrices() {
    // This is a placeholder for future variant price updates
    // Can be extended to fetch new variant data via AJAX if needed
  }

  updatePrices(variant) {
    if (!variant || !variant.price) return;

    const originalPriceEl = this.querySelector('.visual-discount-original');
    const salePriceEl = this.querySelector('.visual-discount-sale');
    
    if (!originalPriceEl || !salePriceEl) return;

    // Get discount percentage or fixed amount from data attributes
    const discountPercent = parseFloat(this.dataset.discountPercent) || 0;
    const discountFixed = parseFloat(this.dataset.discountFixed) || 0;

    let discountedPrice = variant.price;

    if (discountPercent > 0) {
      const discountAmount = variant.price * (discountPercent / 100);
      discountedPrice = Math.round(variant.price - discountAmount);
    } else if (discountFixed > 0) {
      const discountFixedCents = Math.round(discountFixed * 100);
      discountedPrice = variant.price - discountFixedCents;
    }

    // Validate discounted price
    if (discountedPrice > 0 && discountedPrice < variant.price) {
      // Update the display (would need proper Shopify money formatting)
      // This is simplified - in production you'd want to use Shopify's money format
      this.style.display = 'block';
      
      // Hide any fallback price list
      const fallback = this.parentElement?.querySelector('.price-list-fallback');
      if (fallback) {
        fallback.style.display = 'none';
      }
    } else {
      // Invalid discount, show fallback
      this.style.display = 'none';
      const fallback = this.parentElement?.querySelector('.price-list-fallback');
      if (fallback) {
        fallback.style.display = 'block';
      }
    }
  }
}

// Register the custom element
if (!customElements.get('visual-discount')) {
  customElements.define('visual-discount', VisualDiscount);
}

